import styled from "styled-components";

export const BrokerListWrapper = styled.div`
  .table-row {
    td,th {
      min-width: 15%;
    }
  }
  .reasonsTable {
    table-layout: fixed;
    width: 100%;
  }
  .reasonsTable .table-body {
    display: block;
    max-height: 50vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .reasonsTable .table-row th,
  .reasonsTable .table-row td {
    width: 20%;
  }
  .reasonsTable .payloadCell {
    margin: 0;
    background: #f8f9fa;
    padding: 12px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 1.4;
    white-space: pre-wrap;
    word-wrap: break-word;
    word-break: break-word;
    max-height: none;
    overflow: visible;
    text-align: left;
  }
  .add-info {
    flex-wrap: wrap;
  }
  .attempt-button{
    font-size: 15px;
    font-weight: 600;
    padding: 0 12px;
  }
  .payloadCellContent{
    min-width: 25% !important;
  }
  @media (max-width: 475px) {
    .data-button {
      margin-right: 15px;
    }
  }
  @media (max-width: 467px) {
    .data-button {
      margin-right: 15px;
    }
    .add-info {
      justify-content: center !important;
    }
  }
`;

export const MyTableWrapper = styled.div`
  .auctionTable {
    & > tbody {
      cursor: grabbing;
    }
  }
`;

export const TrWrapper = styled.tr`
  cursor: default;

  .action {
    display: flex;
    flex-direction: row;
    gap: 5px;
  }
  .accept {
    color: #5d78ff;
    border: 1px solid #5d78ff;
    font-weight: 700;
    font-size: 14px;
    background: white;
    letter-spacing: 1px;
    padding: 4px 22px;
    border-radius: 3px;
    word-break: normal;
  }

  .reject {
    padding: 4px 22px;
    color: #ff2828;
    font-weight: 700;
    border: 1px solid #ff2828 !important;
    font-size: 14px;
    background: white;
    letter-spacing: 1px;
    border-radius: 3px;
    word-break: normal;
  }

  &.helperContainerClass {
    width: auto;
    border: 1px solid #efefef;
    box-shadow: 0 9px 13px -2px rgba(0, 0, 0, 0.2);
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 3px;

    &:active {
      cursor: grabbing;
    }
  }
`;

export const Handle = styled.div`
  cursor: grab;
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const PriorityCell = styled.td`
  position: relative;
`;

export const PriorityCellContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  position: relative;
`;

